import { initThemeToggle } from './theme-toggle';
import { initFormValidation } from './form-validation';
import { initPhoneMask } from './phone-mask';
import { initAnalytics } from './analytics';
import { initSmoothScroll } from './smooth-scroll';
import { initIntersectionObserver } from './intersection-observer';
import { initMobileMenu } from './mobile-menu';

// Initialize all modules
document.addEventListener('DOMContentLoaded', () => {
  initThemeToggle();
  initPhoneMask();
  initFormValidation();
  initAnalytics();
  initSmoothScroll();
  initIntersectionObserver();
  initMobileMenu();
});
